var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.07496 2.42317C2.20026 2.16438 2.46248 2 2.75001 2H17.25C17.5298 2 17.7863 2.15572 17.9154 2.40393C18.0445 2.65214 18.0247 2.95156 17.8641 3.18062L12.9149 10.238C12.9068 10.2495 12.8983 10.2609 12.8896 10.272C12.7835 10.4064 12.7258 10.5727 12.7259 10.7439V15.0437C12.7259 15.2933 12.6017 15.5266 12.3946 15.6659L9.11525 17.8723C8.88529 18.027 8.58874 18.0423 8.3441 17.912C8.09945 17.7817 7.94659 17.5272 7.94659 17.25V10.8021C7.94388 10.628 7.88548 10.4595 7.77994 10.3211L2.16168 3.21516C1.98335 2.98961 1.94967 2.68197 2.07496 2.42317ZM4.29909 3.5L8.96589 9.40251C9.27225 9.80022 9.44091 10.2868 9.44654 10.7888L9.44659 15.8414L11.2259 14.6443V12.6945V10.7447C11.2258 10.2439 11.3918 9.75705 11.6977 9.3611L15.808 3.5H4.29909Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilters);
export default __webpack_public_path__ + "f148ee815b2398961bcc058ce55a449b.svg";
export { ForwardRef as ReactComponent };